module.exports = __webpack_public_path__ + "static/media/bchat1.365f9a27.png";